<template>
  <div>
    <div class="app-title">
      <h2>工序外安灯</h2>
    </div>
    <div class="app-content">
      <div class="card" style="min-width: 770px;max-width: 1000px">
        <div
          class="row"
          :class="row === 0 ? '' : 'mt-2'"
          v-for="(list, row) in andonTypeDoubleList"
          :key="row"
        >
          <div class="col" v-for="(item, index) in list" :key="index">
            <el-card>
              <el-row class="w-100">
                <div class="row m-auto">
                  <div class="col">
                    <div
                      class="andon_item_level mr-0"
                      :class="lightColors[item.status]"
                    ></div>
                  </div>
                  <div class="col">
                    <div
                      class="andon_item_level ml-0"
                      :class="lightColors[item.responded]"
                    ></div>
                  </div>
                </div>
              </el-row>
              <el-row class="w-100 mt-1 d-flex justify-content-center">
                <el-button
                  type="danger"
                  icon="el-icon-warning"
                  class="andon_button"
                  @click="openDialog(item.index)"
                >
                  {{ item.name }}
                </el-button>
                <el-button
                  type="success"
                  icon="el-icon-check"
                  class="andon_button"
                  @click="confirmReset(item)"
                >
                  复 位
                </el-button>
              </el-row>
            </el-card>
          </div>
        </div>
      </div>

      <div class="card mt-2">
        <el-table :data="andonTaskList" @row-click="rowClick">
          <el-table-column label="任务编号" prop="id"></el-table-column>
          <el-table-column
            label="提交人"
            prop="createdByName"
          ></el-table-column>
          <el-table-column
            label="创建时间"
            prop="createdTime"
          ></el-table-column>
          <el-table-column
            label="报警类型"
            prop="problemAndonTypeName"
          ></el-table-column>
          <el-table-column
            label="是否停工"
            prop="stopWorkStr"
          ></el-table-column>
          <el-table-column
            label="预约开始时间"
            prop="startTime"
          ></el-table-column>
          <el-table-column label="状态" prop="statusStr"></el-table-column>
          <el-table-column
            label="报警子类"
            prop="problemAndonSubtypeName"
          ></el-table-column>
          <el-table-column
            label="响应时间"
            prop="responseTime"
          ></el-table-column>
          <el-table-column label="完成时间" prop="finishTime"></el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      title="安灯问题描述"
      :visible.sync="clickRowDialog"
      @close="clickRow = null"
    >
      <p>
        {{
          clickRow == null || clickRow.problemDescription === ""
            ? "无"
            : clickRow.problemDescription
        }}
      </p>
      <span slot="footer">
        <el-button @click="clickRow = null">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="录入安灯信息"
      top="5vh"
      append-to-body
      :visible.sync="addAndonTaskDialogVisible"
      width="70%"
      @close="closeDialog"
    >
      <el-form :model="form">
        <el-form-item label="预约时间">
          <el-date-picker
            v-model="startTime"
            type="datetime"
            placeholder="开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="安灯子类">
          <el-select
            v-model="form.problemAndonSubtypeId"
            placeholder="选择安灯子类"
          >
            <el-option
              v-for="item in andonSubType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <span>--不选择默认无安灯子类</span>
        </el-form-item>
        <el-form-item label="问题描述">
          <el-input
            v-model="form.problemDescription"
            class="w-75"
            type="textarea"
            autosize
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-switch
            inactive-text="是否停机"
            v-model="form.stopWork"
          ></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addAndonTaskDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAndonTask">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="复位安灯任务"
      :visible.sync="resetVisible"
      :modal="false"
      width="70%"
    >
      <el-table :data="openAndonTaskList" @row-click="rowClickRadio">
        <el-table-column width="30">
          <template slot-scope="scope">
            <el-radio
              :label="scope.row.id"
              v-model="resetItem.taskId"
            ></el-radio>
          </template>
        </el-table-column>
        <el-table-column
          label="任务编号"
          prop="id"
          width="100"
        ></el-table-column>
        <el-table-column label="创建人" prop="createdByName"></el-table-column>
        <el-table-column label="创建时间" prop="createdTime"></el-table-column>
        <el-table-column
          label="描述"
          prop="problemDescription"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetVisible = false">取 消</el-button>
        <el-button type="primary" @click="resetAndonTask">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import emCommonApi from "@/mixin/em/common/api";
import emWebSocketMixin from "@/mixin/em/common/webSocket";
import { getOrDefault } from "../../../../components/LayoutMaps/maps/MapFunction";

export default {
  name: "SimpleAndonManagement",
  mixins: [emCommonApi, emWebSocketMixin],
  data() {
    return {
      form: {
        startTime: null,
        problemAndonTypeId: null,
        problemAndonSubtypeId: null,
        status: 1,
        stopWork: false,
        problemDescription: ""
      },
      startTime: null,
      andonTaskList: [],
      andonTypeList: [],
      andonTypeDoubleList: [],
      andonSubType: [],
      lightColors: ["lc_white", "lc_red", "lc_yellow", "lc_green", "lc_blue"],
      addAndonTaskDialogVisible: false,
      resetVisible: false,
      resetItem: {},
      refreshTimeout: 10 * 60 * 1000,
      openAndonTaskList: [],
      lightInterval: {},
      clickRow: null,

      statusStr: ["未响应", "已响应", "已超时", "已完成", "已撤销"]
    };
  },
  computed: {
    clickRowDialog() {
      return this.clickRow != null;
    }
  },
  mounted() {
    this.getAndonType();
    this.getAndonTask();
    this.listenToRefresh();
    this.setLightInterval(true);
  },
  beforeDestroy() {
    this.setLightInterval(false);
  },
  methods: {
    //被动刷新
    listenToRefresh() {
      Notification.requestPermission()
        .then(() => {
          this.refreshTimeout = 5 * 60 * 1000;
          //连接
          this.$_emWebSocketMixin_connect(() => {
            this.$data.$_emWebSocketMixin_subscribe = "andon/respond";
            //订阅
            this.$_emWebSocketMixin_client.subscribe(
              "/user" + this.$_emWebSocketMixin_subscribeDestination,
              () => {
                this.getAndonTask();
              }
            );
          });
        })
        .catch(() => {
          this.$_emWebSocketMixin_disconnect();
          //订阅失败则切换为高频主动刷新
          this.refreshTimeout = 20 * 1000;
        });
    },
    //定时扫描任务状态
    setLightInterval(open) {
      if (open) {
        this.lightInterval = setInterval(
          this.getAndonTask,
          this.refreshTimeout
        );
      } else {
        clearInterval(this.lightInterval);
      }
    },
    getAndonType() {
      const _api =
        this.$store.state.sithMesAndonType.baseModuleUrl +
        "/sithMesAndonType/findByFilter";
      this.$_emApiMixin_post(_api, {
        parentIdFilter: 0,
        sortingBy: [
          {
            column: "seq",
            order: "asc"
          }
        ]
      }).then(data => {
        let index = 0;
        for (let item of data.data.list) {
          this.andonTypeList.push({
            index: index++,
            id: item.id,
            name: item.name,
            englishName: item.englishName,
            taskId: null,
            status: 3,
            responded: 0
          });
        }
        this.initDoubleList();
      });
    },
    initDoubleList() {
      let temp = [];
      temp.push(this.andonTypeList.slice(0, 4));
      temp.push(this.andonTypeList.slice(4, 8));
      this.andonTypeDoubleList = temp;
    },
    getAndonTask() {
      const _api =
        this.$store.state.sithMesAndonTask.baseModuleUrl +
        "/sithMesAndonTask/simple/andon";
      this.$_emApiMixin_get(_api).then(data => {
        // console.log(data);
        let tempList = [];
        for (let item of data) {
          tempList.push({
            id: item.id,
            createdByName: item.createdByName,
            createdTime: item.createdTime,
            problemAndonTypeId: item.problemAndonTypeId,
            problemAndonTypeName: item.problemAndonTypeName,
            stopWork: getOrDefault("stopWork", item, false),
            stopWorkStr: getOrDefault("stopWork", item, false) ? "是" : "否",
            startTime: item.startTime,
            status: item.status,
            statusStr: this.statusStr[item.status - 1],
            problemAndonSubtypeName: item.problemAndonSubtypeName,
            responseTime: item.responseTime,
            finishTime: item.finishTime,
            problemDescription: item.problemDescription
          });
        }
        this.andonTaskList = tempList;
        this.setLightValue();
      });
    },
    setLightValue() {
      for (let itemType of this.andonTypeList) {
        let hasNoRespondTask = false;
        let hasTask = false;
        itemType.status = 3;
        for (let itemTask of this.andonTaskList) {
          if (
            itemTask.status < 4 &&
            itemType.id === itemTask.problemAndonTypeId
          ) {
            hasTask = true;
            itemType.taskId = itemTask.id;
            if (1 !== itemType.status) {
              itemType.status = itemTask.stopWork ? 1 : 2;
            }
            if (1 === itemTask.status || 3 === itemTask.status) {
              itemType.responded = 0;
              hasNoRespondTask = true;
            } else if (!hasNoRespondTask && 2 === itemTask.status) {
              itemType.responded = 4;
            }
          }
        }
        if (!hasTask) {
          itemType.taskId = null;
          itemType.responded = 0;
          itemType.status = 3;
        }
      }
      this.initDoubleList();
    },
    openDialog(index) {
      let andonType = this.andonTypeList[index].id;
      this.addAndonTaskDialogVisible = true;
      this.startTime = this.$_emApiMixin_dateFormat(new Date());
      this.form.problemAndonTypeId = andonType;
      this.getAndonSubType(andonType);
    },
    saveAndonTask() {
      this.form.startTime = this.$_emApiMixin_dateFormat(this.startTime);
      let url =
        this.$store.state.sithMesAndonTask.baseModuleUrl + "/sithMesAndonTask/";
      this.$store
        .dispatch("api/put", {
          url,
          entity: this.form
        })
        .then(() => {
          this.$message({
            message: "安灯成功！",
            type: "success"
          });
          this.getAndonTask();
        });
      this.addAndonTaskDialogVisible = false;
    },
    closeDialog() {
      this.form.problemAndonTypeId = null;
      this.form.problemAndonSubtypeId = null;
      this.form.stopWork = false;
      this.form.problemDescription = "";
    },
    confirmReset(typeItem) {
      const _api =
        this.$store.state.sithMesPrdPpOperation.baseModuleUrl +
        "/sithMesAndonTask/simple/andon";
      this.$_emApiMixin_get(_api).then(data => {
        // console.log(data);
        let tempList = [];
        for (let item of data) {
          if (item.problemAndonTypeId === typeItem.id && item.status < 4) {
            tempList.push({
              id: item.id,
              createdByName: item.createdByName,
              createdTime: item.createdTime,
              problemAndonTypeId: item.problemAndonTypeId,
              problemAndonTypeName: item.problemAndonTypeName,
              stopWork: getOrDefault("stopWork", item, false),
              stopWorkStr: getOrDefault("stopWork", item, false) ? "是" : "否",
              startTime: item.startTime,
              status: item.status,
              statusStr: this.statusStr[item.status - 1],
              problemAndonSubtypeName: item.problemAndonSubtypeName,
              responseTime: item.responseTime,
              finishTime: item.finishTime,
              problemDescription: item.problemDescription
            });
          }
        }
        this.openAndonTaskList = tempList;
        this.resetItem = typeItem;
        this.resetVisible = true;
      });
    },
    //安灯任务撤销
    resetAndonTask() {
      this.resetVisible = false;
      if (this.resetItem.taskId === null) {
        this.$message({
          message: "没有可复位的安灯任务！",
          type: "warning"
        });
        return;
      }
      let url =
        this.$store.state.sithMesAndonTask.baseModuleUrl +
        "/sithMesAndonTask/selective";
      this.$store
        .dispatch("api/put", {
          url,
          entity: {
            id: this.resetItem.taskId,
            status: 5
          }
        })
        .then(() => {
          this.$message({
            message: "复位成功！",
            type: "success"
          });
          this.getAndonTask();
        });
    },
    getAndonSubType(andonTypeName) {
      const _api =
        this.$store.state.sithMesAndonType.baseModuleUrl +
        "/sithMesAndonType/findByFilter";
      this.$_emApiMixin_post(_api, {
        parentIdFilter: andonTypeName
      }).then(data => {
        this.andonSubType = data.data.list;
      });
    },
    rowClick(row) {
      this.clickRow = row;
    },
    rowClickRadio(row) {
      this.resetItem.taskId = row.id;
    }
  }
};
</script>

<style scoped>
.card >>> .el-card__body {
  padding: 10px;
  background-color: #f1f1f1;
}

.andon_item_level {
  width: 70px;
  height: 70px;
  margin: auto;
  border-radius: 50%;
}

.andon_button {
  width: 70px;
  height: 30px;
  padding: 0;
  font-size: 12px;
  font-weight: bold;
}

.lc_white {
  background-color: white;
}

.lc_red {
  background-color: red;
}

.lc_yellow {
  background-color: yellow;
}

.lc_green {
  background-color: #73dc73;
}

.lc_blue {
  background-color: blue;
}
</style>
